import React from 'react';
import NewGsapStartTest from './NewGsapStartTest';

const Index = () => {
  return (
    <div>
      <NewGsapStartTest />
    </div>
  );
};

export default Index;
